module.exports = __webpack_public_path__ + "img/Qxpress.a79b9b5a.png";